import { render, staticRenderFns } from "./LoaderChip.vue?vue&type=template&id=285bb508&"
import script from "./LoaderChip.vue?vue&type=script&lang=js&"
export * from "./LoaderChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports